/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyDong = createReactComponent("currency-dong", "IconCurrencyDong", [
  ["path", { d: "M6 19h12", key: "svg-0" }],
  ["path", { d: "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-1" }],
  ["path", { d: "M16 16v-12", key: "svg-2" }],
  ["path", { d: "M17 5h-4", key: "svg-3" }]
]);

export { IconCurrencyDong as default };
//# sourceMappingURL=IconCurrencyDong.js.map
